<template>
  <div class="youxiao organization list full-page" data-test="base-organization-list">
    <search-filter-new
      :items="['search']"
      placeholder="请输入机构名称"
      @onSearch="onSearch"
      v-if="isShowSearch"
    />
    <div class="full-page"
      @touchstart="touchStart($event)"
      @touchmove="touchMove($event)"
      @touchend="touchEnd($event)">
      <van-list v-model="loading" :finished="finished">
        <div class="category" v-if="list1.length">正在使用</div>
        <card
          :item="item"
          v-for="item in list1"
          :key="item.id"
          @change="changeOrganisation"
          @edit="toEditOrganization"
          @goto="goto"
          @exit="exit"
          @goDetail="goDetail"
        />
        <div class="category" v-if="list2.length" @click="fold = !fold">
          <span>已过期/未激活</span>
          <van-icon
            class="icon"
            :name="!fold ? 'arrow-up' : 'arrow-down'"
            size="var(--fs-lg)"
            color="var(--g5)"
          />
        </div>
        <card
          v-show="!fold"
          :item="item"
          v-for="item in list2"
          :key="item.id"
          @change="changeOrganisation"
          @edit="toEditOrganization"
          @goto="goto"
          @goDetail="goDetail"
        />
      </van-list>
    </div>

    <pageFooterBtn v-if="!isWorkWx" btnText="新增机构" to="/baseOrganizationAdd" />
  </div>
</template>

<script>
import SearchFilterNew from "@x3/vue/comp/search-filter-new.vue";
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
import card from './org-card.vue';

export default {
  name: 'Organization',
  components: { pageFooterBtn, card, SearchFilterNew },
  data() {
    return {
      loading: false,
      pageTitle: '我的机构',
      list1: [],
      list2: [],
      finished: true,
      fold: true,

      originUseList: [], //正在使用
      originOutList: [], //已过期
      // 下拉出现搜索框
      startY: 0,
      startScroll: 0,
      isShowSearch: false,
      state: 0,
      top: 0,
    };
  },
  computed: {
    ...Vuex.mapState(['companyInfo']),
    isWorkWx() {
      return this.companyInfo.channel == 'YUN_XIAO_WORKWX';
    },
  },
  created() {
    this.$onBus('organizationAddSuccess', this.getData);
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      this.showLoading();
      await this.$api
        .companyList()
        .then(({ data = [] }) => {
          const filterList1 = [],
            filterList2 = [];
          data.forEach(item => {
            if (
              item.currentCompany === 1 ||
              (item.companyProduct && !item.companyProduct.expired)
            ) {
              filterList1.push(item);
            } else {
              filterList2.push(item);
            }
          });
          filterList1.sort((a, b) => b.currentCompany - a.currentCompany);

          this.list1 = filterList1;
          this.list2 = filterList2;
          this.originUseList = filterList1;
          this.originOutList = filterList2;
        })
        .catch(err => console.error('获取我的机构出错', err));
        this.$toast.clear();
        this.loading = false;
    },
    changeOrganisation({ id: companyId, teacherId, companyName, currentCompany, companyProduct }) {
      if (currentCompany === 1) return false;

      if (companyProduct && companyProduct.productCode === 'YUN_XIAO') {
        // 判断机构已经开通云校
        this.$dialog
          .confirm({
            title: '提示',
            message: `是否切换到【${companyName}】`,
          })
          .then(() => {
            this.showLoading();
            this.$api
              .teacherChangeCompany({
                companyId,
                teacherId: teacherId,
              })
              .then(res => {
                vant.Toast.clear();
                if (res.code === 200) {
                  app.teacher.refreshTo({
                    token: res.data.token,
                    path: '/',
                    replace: true
                  });
                } else {
                  this.$notify({
                    type: 'warning',
                    message: res.msg,
                  });
                }
              })
              .catch(err => {
                this.$notify({
                  type: 'warning',
                  message: '切换服务出错，请稍后重试',
                });
                console.error('服务出错，请稍后重试', err);
                vant.Toast.clear();
              });
          });
      } else {
        // 未开通云校，去补充资料
        this.$dialog
          .confirm({
            title: '提示',
            message: '该机构为其他来源同步的机构，若切换请先补充机构资料',
          })
          .then(() => {
            this.$router.push('/supplementInfo/' + companyId);
          })
          .catch(() => {});
      }
    },
    toEditOrganization(item) {
      // 是当前机构并且有编辑机构的权限才可编辑
      if (item.currentCompany === 1 && app.permission.op('edit_company')) {
        this.$router.push('/baseOrganizationEdit?id=' + item.id);
      }
    },
    goDetail(item) {
      // if (item.currentCompany === 1) {
        this.$router.push(`/baseOrganizationEdit?id=${item.id}&isDetail=true`);
      // }
    },
    goto(type) {
      app.teacher.gotoOpenBuy({
        selfType: type,
      });
    },
    // 退出机构
    async exit() {
      await this.$dialog.confirm({
        title: '是否确认退出机构？',
        message: '退出后，你将从此机构主动离职，无法再登入此机构。',
        confirmButtonText: "确定退出",
      });
      this.showLoading();
      await this.$api.leaveOfficeBySelf();
      vant.Toast.clear();
      // 进入登录页
      app.ls.remove("x3-teacher-token");
      app.teacher.switchUser();
    },
    onSearch(val) { //前端过滤筛选机构名
      let queryKey = val.trim(),
        filterList1 = [],
        filterList2 = [];
        this.originUseList.forEach(item => {
          if (item.companyName.includes(queryKey)){
            filterList1.push(item);
          }
        });
        this.originOutList.forEach(item => {
          if (item.companyName.includes(queryKey)){
            filterList2.push(item);
          }
        });
        this.list1 = filterList1;
        this.list2 = filterList2;
    },
    touchStart(e) {
      //记录手指触摸位置y轴位置
      this.startY = e.targetTouches[0].pageY;
      this.startScroll = this.$el.scrollTop || 0;
    },
    touchMove(e) {
      // 获取移动的距离：前移动的y点-初始的y点-初始顶部距离
      let diff = e.targetTouches[0].pageY - this.startY - this.startScroll;
      this.top = Math.floor(diff*0.25) + (this.state === 2 ? 40 : 0)
    },
    touchEnd(e) {
      if(this.state === 2) {
        this.top = 40
        return
      }
      // 判断抬起时的高度，是大于40就开启
      if(this.top >= 40) {
        this.isShowSearch = true;
        this.state = 2
        this.top = 40 
        setTimeout(() => {
          this.state = 0
          this.top = 0
        }, 1000);
      } else {
        this.state = 0
        this.top = 0
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.youxiao.organization.list {
  display: flex;
  flex-direction: column;
  background-color: var(--g1);
  > div.full-page {
    padding: 0 calc(var(--gap) * 16);
    flex: 1;
    overflow-y: auto;
  }
  .van-list {
    margin-top: calc(var(--gap) * 12);
    .category {
      margin-top: calc(var(--gap) * 20);
      margin-bottom: calc(var(--gap) * 8);
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g8);
      font-weight: var(--bold);
    }
  }
}
</style>
